module.exports = __webpack_public_path__ + "static/media/Item 12.82df5ee9.jpg";